import { FormikHelpers } from 'formik';
import { FileUpload, FileUploadProps } from 'components/UI/FileUpload';

type FormFileUploadProps = Omit<FileUploadProps, 'onChange'> & Pick<FormikHelpers<unknown>, 'setFieldValue'>;

const FormFileUpload = ({ setFieldValue, name, ...props }: FormFileUploadProps) => (
  <FileUpload
    {...props}
    name={name}
    onChange={(files) => {
      if (!name) return;
      setFieldValue(name, files);
    }}
  />
);

export { FormFileUpload };
